import {set} from 'vue';
import * as types from './mutation-types';
export default {
  [types.RECEIVE_INTRO] (state, data) {
    set(state, 'intro', {
      brandName: data.brandName,
      brandScore: data.brandScore,
      backgroundPic: data.backgroundPic,
      headPic: data.headPic,
      exclusiveServiceList: data.exclusiveServiceList,
      categoryName: data.categoryName,
      favoriteRate: data.favoriteRate,
      fansCount: data.fansCount
    });
  },
  [types.RECEIVE_COUPONS] (state, data) {
    set(state, 'coupons', data.list);
    set(state, 'shopIds', data.shopIds)
  },
  [types.RECEIVE_ENVIRONMENT] (state, list) {
    set(state, 'environment', list);
  },
  [types.RECEIVE_FEATURE] (state, list) {
    set(state, 'feature', list);
  },
  [types.RECEIVE_BRANCH] (state, list) {
    set(state, 'branch', list);
  },
  [types.RECEIVE_LECTURE] (state, data) {
    set(state, 'lecture', {
      name: data.className,
      list: data.brandClassroomList
    });
  },
  [types.RECEIVE_DETAIL] (state, data) {
    set(state, 'detail', {
      about: {
        buildTimeS: data.buildTimeS,
        shopCount: data.shopCount,
        crewCount: data.crewCount,
        shopScale: data.shopScale
      },
      story: {
        brandStoryPicURL: data.brandStoryPicURL,
        brandStory: data.brandStory
      },
      concept: data.serviceConcept,
      honor: data.honourList,
      media: data.reportList,
      cert: data.credentialList,
      event: data.event
    });
  },
  [types.RECEIVE_FEATURE_CONTENT] (state, data) {
    set(state, 'content', {
      detail: data.detail,
      tag: data.tagName,
      desc: data.alias,
      name: data.name,
      pic: data.pic,
      oldcontent: data.content
    });
  },
  [types.RECEIVE_LECTURE_CONTENT] (state, data) {
    set(state, 'content', {
      detail: data.detail,
      desc: data.alias,
      name: data.name,
      pic: data.pic,
      oldcontent: data.content
    });
  },
  [types.RECEIVE_BRANCH_ALL] (state, data) {
    set(state, 'corporation', data);
  },
  [types.SEND_FOLLOW] (state, data) {
    set(state, 'follow', data);
  },
  [types.ERROR_FOLLOW] (state, data) {
    set(state, 'error', data);
  },
  [types.CHECK_FOLLOW] (state, data) {
    if (state.followed == true && data == true) {
      set(state, 'followed', false);
    } else if (state.followed == true && data == false) {
      //set(state, 'error', 1);
    } else if (state.followed == false && data == true) {
      set(state, 'followed', true);
    } else if (state.followed == false && data == false) {
      //set(state, 'error', 2);
    }
  },
  [types.ADD_FANS_COUNT] (state, data) {
    set(state.intro, 'fansCount', state.intro.fansCount + (state.followed ? 1 : -1))
  },
  [types.SET_LOGIN] (state, status) {
    set(state, 'login', status);
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js